export default __webpack_public_path__ + "static/media/vip-deposit-marathon-challenges-ms.1ee51936.webp";